import { h } from 'hyperapp'

export default (props) =>
    <div class="header-img" style={'background-image: url("'+props.photo+'");'}></div>
